const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',

// Plug Custom Events

  // Triggered on the PDP when the active department changes.
  productDepartmentChange: 'product-department-change',
  // Triggered on the PDP when the active style changes.
  productStyleChange: 'product-style-change',
  // Triggered on the PDP when the active product changes.
  productChange: 'product-change',
};
